import { Box, Typography } from "@mui/material";
import React, { useState } from "react";

const PreviewWrapperImage = ({ file, alt }) => {
  const [preview, setPreview] = useState(null);
  const reader = new FileReader();
  reader.onload = () => {
    setPreview(reader.result);
  };
  reader?.readAsDataURL(file);

  return (
    <Box sx={{ borderRadius: 2 }} position="relative">
      {preview ? (
        <img src={preview} alt={alt} width={400} height={192} style={{ borderRadius: 16, objectFit: "cover" }} />
      ) : (
        "منتظر بمانید..."
      )}

      <Box width="100%" p={2} position="absolute" bottom={0} >
    
        {alt ?     <Typography bgcolor="grey.gb" sx={{borderRadius: 8, width:'fit-content', p:1, margin:"0 auto !important"}}>{alt}</Typography> : null

        }
      </Box>
    </Box>
  );
};

export default PreviewWrapperImage;
